module.exports = __webpack_public_path__ + "img/santa-fe-hybrid-25.d356701b.png";